module.exports = __webpack_public_path__ + "img/scorpio.bde016ee.svg";